export const defaultContent = {
  tiles: [{}, {}, {},],
  displayTitle: "Enter item <strong>title</strong>",
  tileType: "character",
  tileHeadingSize: "lg",
  tileHeadingStyle: "accent-dots",
  theme: 'orange'
};

export const themeColors = [  
  {
    hex: '#FF5500',
    name: 'orange',
    label: 'Orange'
  },
  {
    hex: '#26A957',
    name: 'green',
    label: 'Green'
  },
  {
    hex: '#5687F3',
    name: 'blue',
    label: 'Blue'
  }
]

export const tileLabelOptions = [ 
  {
    label: 'Single Character',
    value: 'character'
  },
  {
    label: 'Word',
    value: 'word'
  },
  {
    label: 'Icon',
    value: 'icon'
  }
]

export const tileHeadingSizeOptions = [ 
  {
    label: 'Large',
    value: 'lg'
  },
  {
    label: 'Medium',
    value: 'md'
  },
  {
    label: 'Small',
    value: 'sm'
  },
]

export const tileHeadingStyleOptions = [
  {
    label: 'Accent Heading-Dots', // accent on the heading, hr is dots
    value: 'accent-dots'
  },
  {
    label: 'Accent Heading-Solid', // accent on the heading, hr is solid
    value: 'accent-solid'
  },
  {
    label: 'Heading-Accent Dots', // accent on the hr, hr is dots
    value: 'dots'
  },
  {
    label: 'Heading-Accent Solid',  // accent on the hr, hr is solid
    value: 'solid'
  },
  {
    label: 'Preheading-Dots',  // accent on the hr, hr is dots, has pretitle/preheading
    value: 'pretitle-dots'
  },
  {
    label: 'Preheading-Solid', // accent on the hr, hr is solid, has pretitle/preheading
    value: 'pretitle-solid'
  }
]

export const titleRTEOptions = {
  controls: ['bold']
}